import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { UiFormControlLabel, UiRadioGroup, UiRadio } from 'ui-components';
import { getCurrentSlice } from 'utils';
import { StyledContentTypeFilter } from './ContentTypeFilter.styles';

/**
 * فیلتر انتخاب نوع مطلب
 */
export const ContentTypeFilter = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { componentName, className, parentPlatform } = props;
  const { selectedValue, platform, isDisabled } = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { setSelectedFilterValue } = getCurrentSlice(reducerName);

  const handleChange = (event) => {
    dispatch(
      setSelectedFilterValue({
        value: event.target.value,
        componentName,
        parentPlatform,
      })
    );
  };

  const contentTypeList = [
    { title: t('common:all'), value: 'both' },
    { title: t('filter:original'), value: 'original' },
    {
      title: t('filter:republished'),
      value: platform === 'linkedin' ? 'repost' : 'copy',
    },
    {
      title: t('filter:quote'),
      value: 'quote',
      isVisible: platform === 'twitter' || platform === 'virasty',
    },
    {
      title: t('filter:reply'),
      value: 'reply',
      isVisible: platform === 'twitter' || platform === 'virasty',
    },
  ];

  return (
    <StyledContentTypeFilter>
      <UiRadioGroup
        className={classNames('filter-content-type', className)}
        value={selectedValue}
        onChange={(event) => handleChange(event)}
      >
        {contentTypeList?.map(({ title, value, isVisible = true }) => {
          if (!isVisible) return null;

          return (
            <UiFormControlLabel
              key={value}
              className='mr-0'
              label={title}
              data-testid={`filter-content-type-${value}-label`}
              control={
                <UiRadio
                  value={value}
                  inputProps={{
                    'data-testid': `filter-content-type-${value}-checkbox`,
                  }}
                />
              }
              disabled={isDisabled}
            />
          );
        })}
      </UiRadioGroup>
    </StyledContentTypeFilter>
  );
};

ContentTypeFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  className: PropTypes.string,
  parentPlatform: PropTypes.string,
};
